import React from 'react'
import { findSportByLeague, getUserJwtToken } from '../../../../utils/utils';
import { browserHistory } from 'react-router';
import axios from 'axios';
import { get_recommendation_lineups_url } from '../../../../utils/apiUtils';
import { getID } from '../../../../firebase';
import { getLineupsForSlateForUser } from '../../../../firestoreQueries';
import { setAutoLineupGenBarOpenFlag } from '../../../../redux/GameInformation/GameInformationAction';
import { connect } from 'react-redux';

const closeLineupModal = () => {
    document.getElementById("staticBackdropLineUp").style.display = "none";
    document.getElementById("staticBackdropLineUp").classList.remove("show");
};

const LineupModal = (props) => {
    function openAutoLineUpComponent() {
        closeLineupModal();
        props.update_auto_lineup_generation_flag(true);
    }
    const gotoLineupHomeRecommendation = async () => {
        const currentSlateID =
            props.game_information_info.gameInformationReducer.slate_id;
        const currentLeague =
            props.game_information_info.gameInformationReducer.sports;
        let data;
        if (currentLeague !== null && currentLeague !== undefined) {
            const sport = findSportByLeague(
                currentLeague,
                props.remoteConfig,
                "GIEXP: gotoLineupHomeRecommendation"
            );
            data = {
                data: {
                    slate_id: currentSlateID,
                    league: currentLeague,
                    sport: sport.toLowerCase(),
                },
            };

            console.log("LineupDataToSend", data);
            const jwtToken = await getUserJwtToken();
            const getAutoLineupData = async () => {
                try {
                    const result = await axios.post(
                        get_recommendation_lineups_url(),
                        data,
                        {
                            headers: {
                                "Authorization": jwtToken,
                                "Content-Type": "application/json",
                                "Access-Control-Allow-Origin": "*",
                            },
                        }
                    );
                    return result;
                } catch (e) {
                    console.log(e);
                    alert(e.response.data);
                    return null;
                }
            };
            const autoLineupData = await getAutoLineupData();

            console.log("LineupData", autoLineupData);

            if (autoLineupData !== null) {
                const route =
                    "/app/" +
                    currentLeague +
                    "/" +
                    currentSlateID +
                    "/lineups/recommendations";

                browserHistory.push({
                    pathname: route,
                    state: {
                        data: autoLineupData.data,
                        myLineups: false,
                        recommendationLineups: true,
                    },
                });
            }
        }
    };
    const handleMyLineupClick = async () => {
        const slate_id =
            props.game_information_info.gameInformationReducer.slate_id;
        const league = props.game_information_info.gameInformationReducer.sports;
        const userId = getID();

        const data = await getLineupsForSlateForUser(slate_id, userId);
        const resp = [];
        data.forEach((doc) => {
            console.log("single lineup", doc.data());
            const singleLineup = doc.data();
            resp.push({
                data: singleLineup.lineup,
                optimizer: singleLineup.lineup.optimizer,
            });
        });

        const route = "/app/" + league + "/" + slate_id + "/mylineups";

        browserHistory.push({
            pathname: route,
            state: { data: resp, myLineups: true, recommendationLineups: false },
        });
    };
    return (
        <div
            className="modal fade"
            id="staticBackdropLineUp"
            data-backdrop="staticLineUp"
            tabindex="-1"
            role="dialog"
            aria-labelledby="staticBackdropLabelLineUp"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header d-flex bg-dark text-center text-white lead">
                        Lineup Generation
                        <button
                            type="button"
                            className="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={closeLineupModal}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="bg-black">
                        <div className="list-group bg-dark text-white m-2 p-2">
                            <dl className="row">
                                <dt className="col-sm-5 text-muted">Generate Lineups</dt>

                                <dd className="col-sm-7 text-muted align-items-center align-self-center">
                                    Create Multiple Lineups (11 max)
                                </dd>
                                <dt className="col-sm-5 text-muted">Recommended Lineups</dt>
                                <dd className="col-sm-7 text-muted">
                                    Spontasy AI recommendations for most likely lineups
                                </dd>
                                <dt className="col-sm-5 text-muted">My Lineups</dt>
                                <dd className="col-sm-7 text-muted">
                                    All saved lineups for the game
                                </dd>
                            </dl>
                        </div>

                        <ul className="list-group m-2">
                            <li
                                className="d-flex list-group-item bg-dark text-primary justify-content-center"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                data-dismiss="modal"
                                onClick={() => {
                                    openAutoLineUpComponent();
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <b>Generate Lineups</b>
                            </li>
                            <li
                                className="d-flex list-group-item bg-dark text-primary justify-content-center"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                data-dismiss="modal"
                                onClick={() => {
                                    gotoLineupHomeRecommendation();
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <b>Recommended Lineups</b>
                            </li>
                            <li
                                className="d-flex list-group-item bg-dark text-primary justify-content-center"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                data-dismiss="modal"
                                onClick={handleMyLineupClick}
                                style={{ cursor: "pointer" }}
                            >
                                <b>My Lineups</b>
                            </li>
                        </ul>
                    </div>

                    <div className="modal-footer bg-black">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                            onClick={closeLineupModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        game_information_info: state
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        update_auto_lineup_generation_flag: (value) =>
            dispatch(setAutoLineupGenBarOpenFlag(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LineupModal)
